import React from 'react';
import { useT } from 'hooks/Locale/useT';

type MessageValue = string | number | boolean | null | undefined;

interface TranslatedMessageProps {
    id: string;
    values?: Record<string, MessageValue>;
    fallback?: string;
}

const TranslatedMessage: React.FC<TranslatedMessageProps> = ({
    id,
    values,
    fallback,
}: TranslatedMessageProps) => {
    const t = useT();
    const translatedMessage = t(id, values, fallback);

    return <>{translatedMessage}</>;
};

export default TranslatedMessage;
